module.exports = vendors_ru_8af309521bf26d17310a;